module.exports = __webpack_public_path__ + "static/media/bagtag.871e07b2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bagtag.webp
// module id = 500
// module chunks = 0